const KEY = "zibuzz_session";

export const Session = {
  save: (data) => {
    const sessionData = { ...(data || {}) };
    delete sessionData.whatsappPhoneNumberId;
    delete sessionData.whatsappWabaId;
    delete sessionData.phoneNumberId;
    delete sessionData.wabaId;

    sessionStorage.setItem(KEY, JSON.stringify(sessionData));
  },

  get: () => {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  },

  clear: () => {
    sessionStorage.removeItem(KEY);
  }
};
